<template>
  <div class="control is-clearfix v-autosuggest">
    <vue-autosuggest
      class="autosuggest"
      :input-props="{ class: 'autosuggest__input input', placeholder }"
      :suggestions="suggestions"
      :value="internalValue"
      @input="inputHandler"
      @selected="inputHandler($event.item)"
    />
  </div>
</template>

<script>
export default {
  props: {
    filterPredicate: {
      type: Function,
      // eslint-disable-next-line
      default: (o, text) => (o.indexOf(text) > -1)
    },
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: 'Search...'
    },
    value: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      internalValue: ''
    };
  },
  computed: {
    suggestions() {
      const filtered = this.options.filter(o =>
        this.filterPredicate(o, this.internalValue)
      );

      return [{ data: filtered }];
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.internalValue = newValue;
      },
      immediate: true
    }
  },
  methods: {
    inputHandler(value) {
      this.internalValue = value;
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-autosuggest {
  /deep/ .autosuggest {
    &__input {
      &--open {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    &__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: $autosuggest-z;
      width: 100%;
      border: 1px solid $border-color;
      box-shadow: $light-background-shadow;
      border-bottom-left-radius: $border-radius;
      border-bottom-right-radius: $border-radius;
      background-color: #ffffff;
      padding: 0;
      overflow: auto;
      max-height: $autosuggest-max-height;

      ul {
        list-style: none;
        padding-left: 0;
        margin: 0;
      }
    }

    &__results-container {
      position: relative;
      width: 100%;
    }

    &__results-item {
      cursor: pointer;
      padding: 0.5rem;

      &:active,
      &:hover,
      &:focus,
      &--highlighted {
        background-color: darken(#ffffff, 10);
      }
    }
  }
}
</style>
